import { SEARCH_KEYWORD_AUTHOR } from '../actions/types';

const initialState = {
  top_authors: [],
  filter: {
    year: undefined,
    country: undefined
  }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SEARCH_KEYWORD_AUTHOR:
            return {
                ...state,
               top_clinical_trials: action.payload.top_authors || [],
               keyword: action.payload.keyword
            }
            break;   
      
        default:
            return state;
            break;
    }
}